import { atom } from 'jotai';

export const idAtom = atom('');
export const usernameAtom = atom('')
export const urlNoticiaAtom = atom('https://www.globo.com/')
export const urlFotoPerfilAtom = atom('')
export const salaAtualAtom = atom('')
export const socket = atom()
export const room = atom('')